






































import { index, destroy } from '@/api/dramas'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  config: Record<string, any> = {
    api: index,
    include: 'brand',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'thumbnail', label: 'T', slot: true, width: 100 },
      { prop: 'overview', label: '', slot: true },
      { prop: 'duration', label: '时长', width: 120 },
      { prop: 'difficulty_zh', label: '难度', width: 120 },
      { prop: 'differences', label: '人数', slot: true, width: 120 },
      { prop: 'created_at', label: '添加时间', width: 150 }
    ]
  }

  async destroyRow (row: Record<string, any>) {
    this.$ask(async () => {
      await destroy(row.id)
      const el: any = this.$refs.table
      el.getItems(1)
      this.$message.success('Data has been deleted')
    })
  }
}
